import React from 'react';

// helpers
import {getDetailedFields, getSummaryFields} from './helpers';
import {useTranslation} from 'react-i18next';

// components
import {ProgressCircle} from '../../ProgressCircle';
import {LabelContentHorizontal} from '../../LabelContentHorizontal';
import {CardBorder} from '../../CardBorder';

// styles
import {
  MobileWrapper,
  MobileCircleWrapper,
  MobileContent,
  StyledLinkPrimary,
} from '../CardDetails-styles';
import {Subtitle} from '../../../styles';

// types
import {CardDetailsSubscriptionProps} from './CardDetailsSubscription';

const CardDetailsSubscriptionMobile = ({
  subscription,
  variant,
}: CardDetailsSubscriptionProps) => {
  const {t} = useTranslation();

  /**
   * Render the fields based on the variant
   */
  const renderFields = () => {
    const fields =
      variant === 'detailed'
        ? getDetailedFields(subscription, t)
        : getSummaryFields(subscription, t);

    return fields.map(({label, content}) => (
      <LabelContentHorizontal
        key={label}
        label={label}
        content={content}
        isFullWidth
      />
    ));
  };

  return (
    <CardBorder variant="white" hasShadow>
      <MobileWrapper>
        {variant === 'summary' && (
          <Subtitle bold="bold">{`${t('global_subscription')} ${subscription.subscriptionName}`}</Subtitle>
        )}
        <MobileCircleWrapper>
          <ProgressCircle percentage={subscription.percentagePaid} />
        </MobileCircleWrapper>
        <MobileContent>
          {renderFields()}
          {variant === 'summary' && (
            <StyledLinkPrimary href={`/subscriptions/${subscription.id}`}>
              {t('dashboard_seeMore')}
            </StyledLinkPrimary>
          )}
        </MobileContent>
      </MobileWrapper>
    </CardBorder>
  );
};

export default CardDetailsSubscriptionMobile;
